/**
 * @generated SignedSource<<ca419193b7fa9f924a974b1b0fcdce55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type priceChangeFavoriteCaseNotification_fragment$data = {
  readonly case: {
    readonly address: string | null | undefined;
    readonly relationType: {
      readonly relationId: string | null | undefined;
    } | null | undefined;
  };
  readonly createdDate: any;
  readonly id: string;
  readonly read: boolean;
  readonly " $fragmentType": "priceChangeFavoriteCaseNotification_fragment";
};
export type priceChangeFavoriteCaseNotification_fragment$key = {
  readonly " $data"?: priceChangeFavoriteCaseNotification_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"priceChangeFavoriteCaseNotification_fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "priceChangeFavoriteCaseNotification_fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "read",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "case",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CaseRelation",
          "kind": "LinkedField",
          "name": "relationType",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "relationId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PriceChangeOnFavoriteCaseNotification",
  "abstractKey": null
};

(node as any).hash = "b81ffc61bfbb285737c4ebb27e9125af";

export default node;
